import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';

export class ApZipcodeValidator {
    public static validate(control: AbstractControl): ValidationErrors {
        return Validators.compose([ApZipcodeValidator.validateZipcode, Validators.maxLength(7)])(control);
    }

    private static validateZipcode(control: AbstractControl): ValidationErrors | null {
        const forbidden = control.value && !/^[1-9][0-9]{3}[\s+]?[a-zA-Z]{2}$/.test(control.value);
        return forbidden ? { zipcode: { value: control.value } } : null;
    }
}
